import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import EditVignette from '../../commons/EditVignette'

const ChangeRoom = ({ appartments, match }) => appartments.length ? (
    <div className="changeRoomButtons">
        { _.find(appartments, { Id: match.params.appartmentId }).Rooms.filter( r => r.Id !== match.params.roomId ).map(room =>
            <div key={room.Id} className="room">
                <EditVignette mode="360" appartment={match.params.appartmentId} room={room.Id} />
                <Link to={"/360/" + match.params.appartmentId + "/" + room.Id}>
                    <img src={ room.VignetteUrl } alt={ room.Name } />
                </Link>
            </div>
        ) }
    </div>
) : null

export { ChangeRoom };

export default connect(
    (state) => state.app
)(ChangeRoom);



// WEBPACK FOOTER //
// ./src/components/360Mode/AppartmentView/ChangeRoom.js